export default __webpack_public_path__ + "static/media/about01.1db51455.png";